export default __webpack_public_path__ + "scripts/resources/assignments/en/chemvlab/stoichiometry/Activity3_a/solutions.json";